enum DateTimeFormat {
  Long = 'MMM D, YYYY, h:mm A',
  TwoDigitsYearLong = 'MMM D, YY, h:mm A',
  LongTheSameSize = 'MMM DD, YYYY, hh:mm A',
  Short = 'lll',
  ShortWithSlashes = 'DD/MM/YYYY',
  UsShortWithSlashes = 'MM/DD/YYYY',
  LongWithSeconds = 'MMM D, YYYY h:mm:ss A',
  ShortDate = 'MMMM DD, YYYY',
  TwoDigitsYearShort = 'MMM D, YY',
  DateWithShowMonth = 'MMM DD, YYYY',
  LongWithDayOfTheWeek = 'dddd, MMMM D, YYYY h:mm A',
  ISOString = 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  ShortTime = 'h:mm A',
  IsoStringDateOnly = 'YYYY-MM-DD',
  MonthYear = 'MMMM YYYY',
  Universal = 'YYYY-MM-DD HH:mm:ss',
}

export default DateTimeFormat;
